import axios from 'axios';
import { ENVIRONMENT_PATHS } from '../constants';

let call;

export const _fetch = (
  path,
  {
    body = {},
    method = 'GET',
    multipart = false,
    forceBlob = false,
    cancel = false,
    params = null,
    token = null
  } = {}
) => {
  if (call && cancel) {
    call.cancel('Only one request allowed at a time.');
  }
  const API_URL =
    process.env.NODE_ENV === 'production' && global.config.baseApiURL
      ? global.config.baseApiURL
      : process.env.REACT_APP_API_URL;

  token = token == null ? JSON.parse(localStorage.getItem('token')) : token;

  const request = {
    method: method,
    headers: {
      Authorization: `Bearer ${token}`
    },
    validateStatus: status => {
      return status < 500; // Reject only if the status code is greater than or equal to 500
    }
  };

  if (!multipart) {
    request.headers = {
      ...request.headers,
      Pragma: 'no-cache',
      'Content-Type': 'application/json'
    };
  }

  if (request) {
    request.params = params;
  }

  if (forceBlob) {
    request.responseType = 'blob';
  }

  if (cancel) {
    call = axios.CancelToken.source();
    request.cancelToken = call.token;
  }

  if (method !== 'GET') {
    if (multipart) {
      const formData = new FormData();
      Object.keys(body).forEach(key => {
        if (Array.isArray(body[key])) {
          body[key].forEach(item => {
            formData.append(key, item);
          });
        } else {
          formData.append(key, body[key]);
        }
      });

      request.data = formData;
    } else {
      request.data = JSON.stringify(body);
    }
  }

  return axios(`${API_URL}/${path}`, request)
    .then(async response => {
      if (response.status === 401) {
        localStorage.removeItem('token');
        // there is no store, so we are using default browser pushState.
        var oldPath = location.pathname;
        ENVIRONMENT_PATHS.forEach(function(path) {
            oldPath = oldPath.replace(path, '');
        });
        return (location.href = `${process.env.PUBLIC_URL}${oldPath}`);
      }
      if (response.status === 403) {
        // there is no store, so we are using default browser pushState.
        return (location.href = `${process.env.PUBLIC_URL}/`);
      }

      const contentType = response.headers['content-type'];

      if (!contentType) {
        return {
          status: response.status
        };
      }

      if (forceBlob && response.status >= 400) {
        return {
          status: response.status,
          payload: await new Response(response.data).json()
        };
      }

      if (forceBlob) {
        return response.data;
      }

      return {
        status: response.status,
        payload: response.data
      };
    })
    .catch(error => {
      throw new Error(error);
    });
};
